import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginView from "@/components/auth/LoginView";
import Layout from "@/components/Layout";
import DashboardOverview from "@/components/dashboard/DashboardOverview";
import RateCardTable from "@/components/rates/RateCardTable";
import ProductsTable from "@/components/products/ProductsTable";
import PeriodCalendarView from "@/components/calendar/PeriodCalendarView";
import CostOfGoodsTable from "@/components/cogs/CostOfGoodsTable";
import SavingsServiceCreditsView from "@/components/savings/SavingsServiceCreditsView";
import SiteSummary from "@/components/sites/SiteSummary";
import Reconciliation from "@/components/reconciliation/Reconciliation";
import ImportExport from "@/components/import/ImportExport";
import DapPricingTable from "@/components/dap/DapPricingTable";
import SummaryOverview from "@/components/summary/SummaryOverview";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function LoginRoute() {
  const { user, ready } = useAuth();
  if (ready && user) return <Navigate to="/" replace />;
  return <LoginView />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/" element={<Protected><DashboardOverview /></Protected>} />
            <Route path="/rate-cards" element={<Protected><RateCardTable /></Protected>} />
            <Route path="/products" element={<Protected><ProductsTable /></Protected>} />
            <Route path="/dap-pricing" element={<Protected><DapPricingTable /></Protected>} />
            <Route path="/sites" element={<Protected><SiteSummary /></Protected>} />
            <Route path="/all-sites" element={<Protected><SummaryOverview /></Protected>} />
            <Route path="/calendar" element={<Protected><PeriodCalendarView /></Protected>} />
            <Route path="/cost-of-goods" element={<Protected><CostOfGoodsTable /></Protected>} />
            <Route path="/savings" element={<Protected><SavingsServiceCreditsView /></Protected>} />
            <Route path="/reconciliation" element={<Protected><Reconciliation /></Protected>} />
            <Route path="/import" element={<Protected><ImportExport /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
